import React from 'react';

import FilterNumberPair from 'components/search_sidebar/filter_number_pair';

import type { FilterProps, NumberFilter } from './types';

export type ChangeEvent = React.ChangeEvent<HTMLInputElement>;

export default function CompCustomFieldNumberFilter({ filter = {}, schema, onChange }: FilterProps<NumberFilter>) {
  return (
    <FilterNumberPair
      filter={filter}
      label={schema.label}
      valueKeys={['min', 'max']}
      onChange={(event: ChangeEvent, key: string) => onChange({ ...filter, [key]: event.target.value })}
    />
  );
}
